import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-object-type',
  template: `
    <div>
      <div class="mb-3">
        <h5 class="mb-0" *ngIf="to.label">{{ to.label }}</h5>
        <small *ngIf="to.description">{{ to.description }}</small>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="showError && formControl.errors">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>

      <formly-field *ngFor="let f of sortByTabIndex()" [field]="f"></formly-field>
    </div>
  `,
})
export class ObjectTypeComponent extends FieldType {
  sortByTabIndex() {
    return this.field.fieldGroup.sort((a, b) => {
      const templateOptionsA = a['templateOptions'];
      const templateOptionsB = b['templateOptions'];

      if (templateOptionsA == null) {
        return 0;
      }

      if (templateOptionsB == null) {
        return 0;
      }

      if ('position' in templateOptionsA && 'position' in templateOptionsB) {
        const tabindexA = templateOptionsA['position'];
        const tabindexB = templateOptionsB['position'];

        return tabindexA > tabindexB ? 1 : tabindexA === tabindexB ? 0 : -1;
      }

      return 0;
    });
  }
}
